import React from "react";
import { Modal, View, Image, StyleSheet, TouchableOpacity } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

import MetaStrip from "@components/MetaStrip";
import CustomText from "@components/CustomText";
import CrossIcon from "@assets/svg/Cross";
import color from "@constants/color";
import SuccessImage from "@assets/images/success-modal.webp";

interface InstantCommissionModalProps {
  isVisible: boolean;
  onClose: () => void;
  commissionMsgs: {
    toastMessage?: string;
    extra_commission_strip?: string;
  };
}

const InstantCommissionModal: React.FC<InstantCommissionModalProps> = ({
  isVisible,
  onClose,
  commissionMsgs,
}) => {
  const insets = useSafeAreaInsets();
  return (
    <Modal
      visible={isVisible}
      animationType="slide"
      presentationStyle="fullScreen"
      statusBarTranslucent
      navigationBarTranslucent
    >
      <View
        style={[
          styles.container,
          { paddingTop: insets.top, paddingBottom: insets.bottom },
        ]}
      >
        <TouchableOpacity style={styles.closeButton} onPress={onClose}>
          <CrossIcon width={20} height={20} />
        </TouchableOpacity>
        <Image source={SuccessImage} style={styles.image} />
        <CustomText style={styles.message}>
          {commissionMsgs.toastMessage || ""}
        </CustomText>
        {commissionMsgs.extra_commission_strip && (
          <MetaStrip
            text={commissionMsgs.extra_commission_strip}
            icon="coin"
            type="BORDERED"
            extraStyling={{ width: "83%", marginBottom: 32 }}
            smallStrip
          />
        )}
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: color.lightGreenshade,
  },
  closeButton: {
    position: "absolute",
    top: 16,
    left: 16,
  },
  image: {
    width: 122,
    height: 120,
  },
  message: {
    fontSize: 20,
    fontWeight: "bold",
    color: color.black,
    textAlign: "center",
    marginVertical: 20,
  },
  button: {
    width: "80%",
  },
});

export default InstantCommissionModal;
